import { defineMessages } from 'react-intl';

export const loanMessages = defineMessages({
  amount: {
    id: 'itemStatus.amount',
    defaultMessage: 'Amount',
  },
  fees: {
    id: 'itemStatus.fees',
    defaultMessage: 'Fees',
  },
});
